<template>
  <div id="ag-grid-demo">
    <vx-card>
        <div class="flex justify-between items-center">
          <div class="filters-container flex flex-wrap items-center justify-start pb-3">
      <!-- Per Page -->
              <div class="md:mb-0">
                <per-page
                  :currentPerPage="per_page"
                  :pageStart="pageStart"
                  :pageEnd="pageEnd"
                  :total="total"
                  @change-per-page="ChangePerPage($event)"
                />
              </div>
              <div class="md:mb-5 ml-6" style="min-width: 200px">
                <label class="vs-input--label">START DATE</label>
                <div>
                  <flat-pickr
                    class="w-100"
                    :config="{
                      ...configdateTimePicker,
                      dateFormat:  'm-d-Y H:i:s',
                      defaultDate: new Date().setHours(0, 0, 0),
                    }"
                    v-model="start_time"
                    @input="SetDatetimeForStart"
                  />
                </div>
              </div>
              <div class="md:mb-5 ml-6" style="min-width: 200px">
                <label class="vs-input--label">END DATE</label>
                <div>
                  <flat-pickr
                    class="w-100"
                    :config="{
                    ...configdateTimePicker,
                      dateFormat:  'm-d-Y H:i:s',
                      defaultDate: new Date().setHours(23, 59, 59),
                    }"
                    v-model="end_time"
                    @input="SetDatetimeForEnd"
                  />
                </div>
              </div>
              <div class="smsc-navigation__col md:mb-5 ml-6">
                <div class="smsc-navigation__item">
                  <label class="vs-input--label">Step</label>
                  <v-select
                    class="w-100"
                    label="name"
                    :options="steps"
                    v-model="step_value"
                    @input="selected.step = $event && $event.value"
                  />
                </div>
                <div class="smsc-navigation__item" style="opacity: 0; height: 1px; overflow: hidden">
                  <label class="vs-input--label">Step</label>
                  <v-select
                    label="name"
                    :options="steps"
                    :searchable="false"
                    :value="{ name: 'All', value: 'all' }"
                  />
                </div>
              </div>
              <div class="smsc-navigation__col ml-6">
                <vs-button @click="GetListByFiltered()">Sent</vs-button>
              </div>
              <div class="buttons-container flex flex-wrap items-center justify-end pb-3 ml-6">
                <vs-button
                  class="mt-3 ml-3"
                >Export as CSV</vs-button>
              </div>
           </div>
      <!-- Table -->
        </div>
      <div class="div-ag-grid-vue">
        <ag-grid-vue
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="list"
          @gridReady="GridReady"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="isFloatingFilter"
          :pagination="true"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
        >
        </ag-grid-vue>

      </div>

      <!-- Pagination -->
      <vs-pagination
        style="margin-top: 36px"
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'
import DateTimeMixin from '@/mixins/datetime.js'

// Packages
import vSelect from 'vue-select'
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import flatPickr from 'vue-flatpickr-component'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import 'flatpickr/dist/flatpickr.css'

// Components
// import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
// import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
// import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
// import CellRendererActions from "./cell-renderer/CellRendererActions.vue";


export default {
mixins: [TableMixin, DateTimeMixin],
  components: {
    AgGridVue,
    flatPickr,
    vSelect,

    // CellRendererLink,
    // CellRendererStatus,
    // CellRendererVerified,
    // CellRendererActions,
  },
  data() {
    return {
      step_value: { name: 'Hourly', value: 'hour' },
      steps: [
        { name: 'All', value: 'all'},
        { name: 'Hourly', value: 'hour' },
        { name: 'Daily', value: 'day' }
      ],
      // table header value
      start_time:  new Date().setHours(0, 0, 0),
      end_time:  new Date().setHours(23, 59, 59),
      columnDefs: [

        {
           headerName: 'Time',
           field: 'sms_time'
        },
        // {
        //   headerName: 'Date',
        //   field: 'sms_time'
        // },
        {
          headerName: 'Total',
          field: 'relay_dlr_content',
        },
        {
          headerName: 'Success',
          field: 'delivered',
        },
        {
          headerName: 'Cost',
          field: 'tx_cost',
        },
        {
          headerName: 'Avg Rate',
        },
      ],

      // Cell Renderer components
      components: {
        // CellRendererActions,
        // CellRendererStatus
      },
      searchProduct: ''
    }
  },
  created() {
    this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
    this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
    this.GetList()
  },
  methods: {
    SetDatetimeForEnd() {
      this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
    },
    SetDatetimeForStart() {
      this.filters.start_time =  parseInt((new Date(this.start_time).getTime()/1000))
    },
    GetList() {
      this.$vs.loading()
      this.$store.dispatch('log/GetList', {
        ...this.filters,

        from:this.page,
        count:this.per_page || 10,
        step:this.step_value.value,
        fields:"tx_cost%2Cdelivered%2Csent",
        per_page: this.per_page || 10,

      })
      .then(res => {
        this.list = res.data.map(this.TransformReseller)
        this.total = res.total
      })
      .catch()
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    GetListByFiltered() {
       this.$vs.loading()
       this.$store.dispatch('log/GetListByFiltered', {
        ...this.filters,
        step: this.step_value.value || '',
        page: 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
        sms_time: this.start_time
      })
      .then(res => {
        this.list = res.data.map(this.TransformReseller)
        this.total = res.total
      })
      .catch()
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    ChangePerPage(per_page) {
      this.$router.push({ query: { 'page': 0, 'per-page': per_page } })
      this.page = 0
      this.per_page = per_page
      console.log(this.per_page)
      this.GetList()
    },

    TransformReseller(item) {
      console.log(item)
      return {
        refreshData: this.GetList,
        sms_time: format(new Date(item.sms_time * 1000), 'yyyy-dd-MM HH:mm:ss'),
        delivered: item.delivered,
        tx_cost: item.tx_cost,
        relay_dlr_content: item.sent
      }
    },
  }
}
</script>
<style>
    .filter_input_smsreport{
        padding: 17px;
        padding-left: 55px;
        width: 220px;
        height: 42px;
        border: 1px solid lightgray;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
        margin-left: 20px;
        margin-top: 2px;
        border-radius: 4px;
    }
    .has-search .form-control-smsreport-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 35px;
        margin-top: 17px;
    }
</style>
<style scoped lang="scss">
 /*.div-ag-grid-vue /deep/ .ag-overlay-no-rows-center{*/
 /*   margin-top: 39px!important;*/
 /* }*/
</style>
